// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[type='text']::-moz-placeholder {\n  --tw-placeholder-opacity: 1;\n  color: rgba(156, 163, 175, var(--tw-placeholder-opacity))\n}\ninput[type='text']:-ms-input-placeholder {\n  --tw-placeholder-opacity: 1;\n  color: rgba(156, 163, 175, var(--tw-placeholder-opacity))\n}\ninput[type='text']::placeholder {\n  --tw-placeholder-opacity: 1;\n  color: rgba(156, 163, 175, var(--tw-placeholder-opacity))\n}\n", ""]);
// Exports
module.exports = exports;
